import { groupService } from '@/data/services/group/group-service'
import { Account } from '@/domain/usecases'

interface GroupFilterOptions {
  companies: Array<{ value: number; label: string }>
  typegroups: Array<{ value: string; label: string }>
}

export type CompanyManagerGroupsLoaderType = {
  filterOptions: GroupFilterOptions
}

export async function loadCompanyManagerGroups(
  account: Account.Model
): Promise<CompanyManagerGroupsLoaderType> {
  try {
    const filterOptions = await groupService.fetchFilterOptions(account.company.uniqueId)
    return {
      filterOptions: {
        companies: filterOptions.companies,
        typegroups: filterOptions.typegroup
      }
    }
  } catch (error) {
    console.error('Error loading group filters:', error)
    return {
      filterOptions: {
        companies: [],
        typegroups: []
      }
    }
  }
}
